import axios from "axios/dist/axios";
import {getCookie, showToast} from "../utils";

/**
 * Configured Axios instance with CSRF token handling
 */
export const api = axios.create({
    headers: {
        "Content-Type": "application/json"
    },
    withCredentials: true
});

/**
 * Request interceptor: Adds CSRF token to headers
 */
api.interceptors.request.use((config) => {
    const csrfToken = getCookie('csrftoken');
    if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
    }
    return config;
});

/**
 * Response interceptor: Error handling
 */
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Error handling can be extended here if needed
        // Example: trigger toast notification
        showToast(error.response?.data?.detail || "API Error", "danger");
        return Promise.reject(error);
    }
);
